export enum RequiredType {
    REQUIRED = 'REQUIRED',
    POSSIBLE = 'POSSIBLE'
}
